import { PageTitle } from "@/components/page-title";
import { FinancialAccountForm } from "./_form";
import { FinancialAccount, PropsWithUser } from "@/types";

type Props = {
  financial_account: FinancialAccount;
};

function FinancialAccountShow({ financial_account }: PropsWithUser<Props>) {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <PageTitle>Edit financial account</PageTitle>
      <FinancialAccountForm financial_account={financial_account} />
    </div>
  );
}

export default FinancialAccountShow;
